import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Dropdown, IDropdownStyles } from '@fluentui/react/lib/Dropdown';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import {
	IStackItemStyles,
	IStackTokens,
	Stack,
} from '@fluentui/react/lib/Stack';
import { TextField, ITextFieldStyles } from '@fluentui/react/lib/TextField';
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { updateSubDepartmentAsync } from '../../redux/actions';
import { ISubDepartment, IStore } from '../../schemas';

import * as OPTIONS from '../options';

const stackTokens: IStackTokens = {
	childrenGap: 5,
};

const stackItemStyles: IStackItemStyles = {
	root: {
		flex: 1,
	},
};

const verticalStackTokens: IStackTokens = {
	childrenGap: 5,
};

const textFieldSytles: Partial<ITextFieldStyles> = {
	field: {
		color: '#000',
	},
	subComponentStyles: {
		label: {
			root: { fontWeight: 'normal', color: '#484644' },
		},
	},
};

const dropdownStyles: Partial<IDropdownStyles> = {
	title: { color: '#484644', border: 'none' },
	label: {
		fontWeight: 'normal',
		color: '#484644',
	},
	subComponentStyles: {
		label: {
			root: { fontWeight: 'normal', color: '#484644' },
		},
		panel: {},
		multiSelectItem: {},
	},
};

const buttonStyle = {
	root: {
		marginLeft: 8,
		border: 'none',
	},
};

class SubDepartmentPanelEdit extends Component<any, any> {
	state = {
		detail: {} as ISubDepartment
	};

	/**
	 * Close the add user panel
	 */
	closePanel = () => {
		this.props.onDismiss(false);
	};

	doSubAction = (actionType) => {
		return () => this.props.onSubAction(actionType, this.state.detail);
	};

	onBtnSaveClick = (_) => {
		const { detail: detail } = this.state;
		this.props.updateSubDepartmentAsync(detail);
		this.props.onDismiss(false);
	};

	/**
	 * @returns Panel footer component
	 */
	onRenderFooterContent = () => {
		return (
			<div style={{ display: 'flex', justifyContent: 'right' }}>
				<DefaultButton styles={buttonStyle} onClick={this.closePanel}>
					Cancel
				</DefaultButton>
				<PrimaryButton styles={buttonStyle} onClick={this.onBtnSaveClick}>
					Save
				</PrimaryButton>
			</div>
		);
	};

	onTextChanged = (name) => {
		const { detail: detail } = this.state;

		return (_, data) => {
			this.setState({
				detail: { ...detail, [name]: data },
			});
		};
	};

	onDropDownChanged = (name) => {
		const { detail: detail } = this.state;

		return (_, data) => {
			const optionObj = {
				[`${name}`]: data.text,
			};
			this.setState({
				detail: { ...detail, ...optionObj },
			});
		};
	};

	componentDidMount() {
		const { detail } = this.props;
		this.setState({
			detail: { ...detail },
		});
	}

	render() {
		const { dictionary } = this.props;
		const { detail: detail } = this.state;
		return (
			<>
				<Panel
					isOpen={this.props.isOpen}
					onDismiss={this.closePanel}
					onRenderFooterContent={this.onRenderFooterContent}
					type={PanelType.medium}
					headerText='Edit SubDepartment'
					isFooterAtBottom={true}
					isLightDismiss={false}
					styles={{
						navigation: { backgroundColor: '#f5f5f5' },
						main: {
							backgroundColor: '#f5f5f5',
						},
						commands: { zIndex: '9999' },
					}}
				>
					<Stack tokens={verticalStackTokens}>
						<Stack horizontal tokens={stackTokens}>
							<Stack.Item grow={1} styles={{ root: { width: '50%' } }}>
								<Dropdown
									key='dpTeam'
									label='Team'
									options={[{ key: '', text: '' }].concat(
										dictionary.teams.map((item) => {
											return { key: item.itemValue, text: item.itemName };
										})
									)}
									styles={dropdownStyles}
									onChange={this.onDropDownChanged('team')}
									selectedKey={detail.name}
								/>
							</Stack.Item>

							<Stack.Item grow={1} styles={{ root: { width: '50%' } }}>
								<TextField
									key='txtDepartment'
									label='Department'
									borderless
									styles={textFieldSytles}
									onChange={this.onTextChanged('department')}
									value={detail.department}
								/>
							</Stack.Item>
						</Stack>
					</Stack>
				</Panel>
			</>
		);
	}
}

export default connect(
	(state: IStore) => ({
		dictionary: state.dictionary,
	}),
	{
		updateSubDepartmentAsync,
	}
)(SubDepartmentPanelEdit);
